import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";

import type { PriceBarsParams, PriceBarsResponse } from "./types";

const POLL_MS = 30_000;          // spec §9.1 — calendar parity
const STALE_MS = 15_000;
const GC_MS = 5 * 60_000;

export function useMaterialPriceQuery(params: PriceBarsParams) {
  return useQuery<PriceBarsResponse>({
    queryKey: [
      "material",
      params.material_id,
      "prices",
      params.timeframe,
      params.since,
      params.until ?? null,
    ],
    queryFn: () => api.getMaterialPrices(params),
    refetchInterval: POLL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
  });
}
